import { render, staticRenderFns } from "./d-reviewer-search-form.vue?vue&type=template&id=97b1af16&"
import script from "./d-reviewer-search-form.vue?vue&type=script&lang=js&"
export * from "./d-reviewer-search-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports